export default __webpack_public_path__ + "fontawesome-webfont.svg?0db1520f47986b6c755a66d554bc370d";